import { IS_PRODUCT } from '@/constants';

type KakaoPixel = ReturnType<NonNullable<Window['kakaoPixel']>>;

type KakaoPixelCall = {
  [K in keyof KakaoPixel]: [type: K, ...args: Parameters<KakaoPixel[K]>];
}[keyof KakaoPixel];

export type { KakaoPixel, KakaoPixelCall };

const waitForKakaoPixel = () =>
  new Promise<boolean>((resolve) => {
    if (window.kakaoPixel) return resolve(true);

    let count = 0;
    const timer = setInterval(() => {
      if (window.kakaoPixel) {
        clearInterval(timer);
        resolve(true);
      } else if (++count >= 20) {
        clearInterval(timer);
        resolve(false);
      }
    }, 250);
  });

const dispatchPixelEvent = (pixel: KakaoPixel, event: KakaoPixelCall) => {
  switch (event[0]) {
    case 'pageView':
      pixel.pageView();
      break;
    case 'completeRegistration':
      pixel.completeRegistration();
      break;
    case 'viewContent':
      pixel.viewContent(event[1]);
      break;
    case 'purchase':
      pixel.purchase(event[1]);
      break;
    case 'missionComplete':
      pixel.missionComplete(event[1]);
      break;
  }
};

export const trackKakaoPixelEvent = async (
  pixelId: string,
  ...event: KakaoPixelCall
) => {
  if (!IS_PRODUCT || typeof window === 'undefined') return;

  try {
    const ready = await waitForKakaoPixel();
    if (!ready || !window.kakaoPixel) return;

    dispatchPixelEvent(window.kakaoPixel(pixelId), event);
  } catch (e) {
    console.warn('[KakaoPixel] 이벤트 전송 실패', {
      eventType: event[0],
      error: e,
    });
  }
};

export const KAKAO_MOMENT_PIXEL_ID = '2419359489528909570';
